
const Main = () => import('@/views/main');
const buyOrder = () => import('@/views/order/buyOrder');
const useOrder = () => import('@/views/order/useOrder');
const userVerify = () => import('@/views/order/userVerify');
const curriculumOrder = () => import('@/views/order/curriculumOrder');
const retailOrder = () => import('@/views/order/retailOrder');
const amendTicket = () => import('@/views/order/amendTicket');
const usingDetail = () => import('@/views/order/usingDetail');
const allOrder = () => import('@/views/order/all-order');
// const userTicket = () => import('@/views/order/user-ticket');
const operateRecord = () => import('@/views/order/operate-record');
const mealOrder = () => import('@/views/order/meal-order');
const storedValueOrder = () => import('@/views/order/stored-value-order');
const storedValueDetail = () => import('@/views/order/stored-value-detail');
// const giveTicket = () => import('@/views/order/give-ticket');
const sendDetail = () => import('@/views/order/send-detail');
const marketingOrder = () => import('@/views/order/marketing-order');
const marketingOrderDetail = () => import('@/views/order/marketing-order-detail');
const exchangeGiftOrder = () => import('@/views/order/exchange-order');
const exchangeGiftGroupOrder = () => import('@/views/order/exchange-group-order');
const exchangeGroupOrderDetail = () => import('@/views/order/exchange-group-order-detail');
const pointOrder = () => import('@/views/order/point-order');
const pointOrderDetailTicket = () => import('@/views/order/point-order-detail-ticket');
const pointOrderDetailCoupon = () => import('@/views/order/point-order-detail-coupon');
const pointOrderDetailRetail = () => import('@/views/order/point-order-detail-retail');
const partyOrder = () => import('@/views/order/party-order');
const createPartyOrder = () => import('@/views/order/create-party-order');
const partyOrderDetail = () => import('@/views/order/party-order-detail');

export default [{
    path: '/order',
    name: 'order',
	redirect: {
		name: 'allOrder'
	},
    component: Main,
    meta: {
        hide: false,
        name: '订单管理',
        unfold: true,
		iconType: "16"
    },
    children: [
        {
            path: "/allOrder",
            name: "allOrder",
            component: allOrder,
            meta: {
                name: "票券订单管理"
            },
            children: [
                {
                    path: "curriculumOrder",
                    name: "curriculumOrder",
                    component: curriculumOrder,
                    meta: {
                        name: "课程订单详情"
                    }
                },
                {
                    path: "buyOrder/:orderId",
                    name: "buyOrder",
                    component: buyOrder,
                    meta: {
                        name: "票券订单详情"
                    },
                    children: [
                        {
                            path: "amendTicket",
                            component: amendTicket,
                            name: "amendTicket",
                            hide: true,
                            unfold: false,
                            meta: {
                                name: '票券信息修改'
                            },
                        },
                        {
                            path: "usingDetail",
                            component: usingDetail,
                            name: "usingDetail",
                            hide: true,
                            unfold: false,
                            meta: {
                                name: '使用详情'
                            },
                        },
                        {
                            path: "operateRecordTicket",
                            component: operateRecord,
                            name: "operateRecordTicket",
                            hide: true,
                            unfold: false,
                            meta: {
                                name: '操作记录'
                            },
                        },
                        {
                            path: "sendDetail",
                            component: sendDetail,
                            name: "sendDetail",
                            meta: {
                                name: '赠品'
                            },
                        },
                    ]
                },
            ]
        },
        {
            path: "/ticketReservationRecord",
            name: "ticketReservationRecord",
            component: useOrder,
            meta: {
                name: "票券预约记录"
            }
        },
        {
            path: "/ticketVerifyRecord",
            name: "ticketVerifyRecord",
            component: userVerify,
            meta: {
                name: "票券核销记录"
            }
        },
        {
            path: "/retailOrder",
            name: "retailOrder",
            component: retailOrder,
            hide: true,
            unfold: false,
            meta: {
                name: "零售订单管理"
            }
        },
        // {
        //     path: "/mealOrder",
        //     name: "mealOrder",
        //     component: mealOrder,
        //     hide: true,
        //     unfold: false,
        //     meta: {
        //         name: "餐饮订单管理"
        //     }
        // },
        // {
        //     path: "/storedValueOrder",
        //     name: "storedValueOrder",
        //     component: storedValueOrder,
        //     hide: true,
        //     unfold: false,
        //     meta: {
        //         name: "储值订单管理"
        //     },
        //     children: [
        //         {
        //             path: "storedValueDetail",
        //             component: storedValueDetail,
        //             name: "storedValueDetail",
        //             meta: {
        //                 name: '储值订单详情'
        //             },
        //         },
        //     ]
        // },
        // {
        //     path: "/marketingOrder",
        //     name: "marketingOrder",
        //     component: marketingOrder,
        //     hide: true,
        //     unfold: false,
        //     meta: {
        //         name: "营销订单管理"
        //     },
        //     children: [
        //         {
        //             path: "/marketingOrderDetail",
        //             name: "marketingOrderDetail",
        //             component: marketingOrderDetail,
        //             hide: true,
        //             unfold: false,
        //             meta: {
        //                 name: "订单详情"
        //             }
        //         },
        //     ],
        // },
        {
            path: "/exchangeGiftOrder",
            name: "exchangeGiftOrder",
            component: exchangeGiftOrder,
            hide: true,
            unfold: false,
            meta: {
                name: "兑换礼券订单"
            },
            children: [
                {
                    path: "/marketingOrderDetail",
                    name: "marketingOrderDetail",
                    component: marketingOrderDetail,
                    hide: true,
                    unfold: false,
                    meta: {
                        name: "订单详情"
                    }
                },
            ],
        },
        {
            path: "/exchangeGiftGroupOrder",
            name: "exchangeGiftGroupOrder",
            component: exchangeGiftGroupOrder,
            hide: true,
            unfold: false,
            meta: {
                name: "团购销售订单"
            },
            children: [
                {
                    path: "/exchangeGroupOrderDetail",
                    name: "exchangeGroupOrderDetail",
                    component: exchangeGroupOrderDetail,
                    hide: true,
                    unfold: false,
                    meta: {
                        name: "团购销售订单详情"
                    }
                },
            ],
        },
        {
            path: "pointOrder",
            name: "adminPointOrder",
            component: pointOrder,
            meta: {
                name: "积分订单管理"
            },
            children: [
                {
                    path: "detailTicket/:transNo",
                    name: "pointOrderDetailTicket",
                    component: pointOrderDetailTicket,
                    meta: {
                        name: "订单详情"
                    }
                },
                {
                    path: "detailCoupon/:tradeNo",
                    name: "pointOrderDetailCoupon",
                    component: pointOrderDetailCoupon,
                    meta: {
                        name: "订单详情"
                    }
                },
                {
                    path: "detailRetail/:tradeNo",
                    name: "pointOrderDetailRetail",
                    component: pointOrderDetailRetail,
                    meta: {
                        name: "订单详情"
                    }
                },
            ]
        },
        {
            path: "partyOrder",
            name: "partyOrder",
            component: partyOrder,
            meta: {
                name: "派对订单",
                hide: false,
                unfold: false,
            },
            children: [
                {
                    path: "/createPartyOrder",
                    name: "createPartyOrder",
                    component: createPartyOrder,
                    meta: {
                        hide: true,
                        unfold: false,
                        name: "创建派对订单"
                    }
                },
                {
                    path: "/editPartyOrder/:orderId",
                    name: "editPartyOrder",
                    component: createPartyOrder,
                    meta: {
                        hide: true,
                        unfold: false,
                        name: "编辑"
                    }
                },
                {
                    path: "/partyOrderDetail/:orderId",
                    name: "partyOrderDetail",
                    component: partyOrderDetail,
                    meta: {
                        hide: true,
                        unfold: false,
                        name: "派对订单详情"
                    }
                },
            ],
        }
    ]
}]

